import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { MaterialModule } from '../../material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DocIntrareComponent } from './doc-intrare/doc-intrare.component';
import { DocumentInternComponent } from './doc-intern/document-intern.component';
import { DocumentIesireComponent } from './doc-iesire/document-iesire.component';
import { InfoDocumentComponent } from './info-doc/info-document.component';
import { SubsemnatulComponent } from './info-doc/subsemnatul/subsemnatul.component';
import { IstoricComponent } from './info-doc/istoric/istoric.component';
import { ActivitateFluxActiuniOperatorComponent } from './info-doc/activitate-actiuni/activitate-flux-actiuni-operator.component';
import { NewDestinationComponent } from './info-doc/activitate-actiuni/add-new-destination/new-destination.component';
import { SafeHtmlPipe } from './safe-html-pipe';
import { ActiuniDocumentComponent } from './info-doc/actiuni-document/actiuni-document.component';
import { ActiuniCerereCardComponent } from './info-doc/actiuni-cerere-card/actiuni-cerere-card.component';
import { ModalInchidereLucrareComponent } from './info-doc/modal-inchidere-lucrare/modal-inchidere-lucrare.component';
import { EditContinutDocumentComponent } from './info-doc/subsemnatul/edit-continut-document/edit-continut-document.component';
import { EditObservatiiDocumentComponent } from './info-doc/subsemnatul/edit-observatii-document/edit-observatii-document.component';
import { EditInfoComponent } from './info-doc/edit-info/edit-info.component';
import { EditEmitentExternComponent } from './info-doc/subsemnatul/edit-emitent-extern/edit-emitent-extern.component';
import { OpenEmailComponent } from './info-doc/activitate-actiuni/open-email/open-email.component';
import { ModalFinalizareActivityComponent } from './info-doc/modal-finalizare-activity/modal-finalizare-activity.component';
import { PreluareNrRegistruComponent } from './info-doc/preluare-nr-registru/preluare-nr-registru.component';
import { DocumentFunctiiAssignmentComponent } from './info-doc/document-functii-assignment/document-functii-assignment.component';
import { DocumentAssignmentComponent } from './info-doc/document-assignment/document-assignment.component';
import { DocumentGenerabilComponent } from './info-doc/document-generabil/document-generabil.component';
import { EditDocumentOficialComponent } from './info-doc/document-generabil/edit-document-oficial/edit-document-oficial.component';
import { IstoricDocumentGenerabilComponent } from './info-doc/document-generabil/istoric-document-generabil/istoric-document-generabil.component';
import { UpdateGenerabilValabilityComponent } from './info-doc/document-generabil/update-generabil-valability/update-generabil-valability.component';
import { RegistruValabilityComponent } from './info-doc/registru-valability/registru-valability.component';
import { RegistruValabilityExtendedComponent } from './info-doc/registru-valability-extended/registru-valability-extended.component';
import { SignaturePositionModalComponent } from './info-doc/signature-position-modal/signature-position-modal.component';
import { DraftValidareComponent} from './info-doc/draft-validare/draft-validare.component';
import { CetateanUploadComponent } from './info-doc/cetatean-upload/cetatean-upload.component';
import { UploadAnexeComponent } from './info-doc/upload-anexe/upload-anexe.component';
import { InfoDocumenteSabloaneComponent } from './info-doc/info-documente-sabloane/info-documente-sabloane.component';
import { GenerareAwbComponent } from './info-doc/generare-awb/generare-awb.component';
import { DocumentSignatureFlowDialogComponent } from './info-doc/document-signature-flow-dialog/document-signature-flow-dialog.component';
import { DocumentRedactionFlowDialogComponent } from './info-doc/document-redaction-flow-dialog/document-redaction-flow-dialog.component';
import { RedactionStepEditDialogComponent } from './info-doc/document-redaction-flow-dialog/redaction-step-edit-dialog/redaction-step-edit-dialog.component';
import { AddAwbComponent } from './info-doc/generare-awb/add-awb/add-awb.component';
import { OperatorSignStatusComponent } from './info-doc/operator-sign-status/operator-sign-status.component';
import { EuropeanDatePipe } from '../../shared/pipes/european-date.pipe';
import { RichEditorModule } from '../../shared/components/rich-editor/rich-editor.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DocumentTemplateModule } from '../../platform/nomenclatoare/document-template/document-template.module';


@NgModule({
    declarations: [
        DashboardComponent,
        DocIntrareComponent,
        DocumentInternComponent,
        DocumentIesireComponent,
        InfoDocumentComponent,
        SubsemnatulComponent,
        IstoricComponent,
        ActivitateFluxActiuniOperatorComponent,
        NewDestinationComponent,
        SafeHtmlPipe,
        ActiuniDocumentComponent,
        ActiuniCerereCardComponent,
        ModalInchidereLucrareComponent,
        EditContinutDocumentComponent,
        EditObservatiiDocumentComponent,
        EditInfoComponent,
        EditEmitentExternComponent,
        OpenEmailComponent,
        ModalFinalizareActivityComponent,
        PreluareNrRegistruComponent,
        DocumentFunctiiAssignmentComponent,
        DocumentAssignmentComponent,
        DocumentGenerabilComponent,
        EditDocumentOficialComponent,
        IstoricDocumentGenerabilComponent,
        UpdateGenerabilValabilityComponent,
        RegistruValabilityComponent,
        RegistruValabilityExtendedComponent,
        SignaturePositionModalComponent,
        DraftValidareComponent,
        CetateanUploadComponent,
        UploadAnexeComponent,
        InfoDocumenteSabloaneComponent,
        GenerareAwbComponent,
        AddAwbComponent,
        OperatorSignStatusComponent,
        EuropeanDatePipe,
        DocumentSignatureFlowDialogComponent,
        DocumentRedactionFlowDialogComponent,
        RedactionStepEditDialogComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        MatAutocompleteModule,
        RichEditorModule,
        DragDropModule,
        DocumentTemplateModule,
    ],
    exports: [
        DashboardComponent,
        SignaturePositionModalComponent,
        InfoDocumentComponent,
    ],
})
export class DashboardModule { }
